import { useParams } from 'react-router'

import { RouteNamesEnum } from '@ui/router/routes'

import useAppNavigation from './useAppNavigation'

export const useNavigateToNode = () => {
  const { navigateTo } = useAppNavigation()
  const { instanceId, pipelineId } = useParams<{ instanceId: string; pipelineId: string }>()

  return (nodeId: string) => {
    // expect no pipelineId if in RouteNamesEnum.NEW_PIPELINE
    if (pipelineId) navigateTo(RouteNamesEnum.EXISTING_PIPELINE_NODE, { instanceId, pipelineId, nodeId })
  }
}
